const defaultAuthRedirect =
  process.env.NEXT_PUBLIC_FF_DEFAULT_TO_MY === 'true'
    ? process.env.NEXT_PUBLIC_BASE_URL_MY || 'https://my.compassion.com'
    : process.env.NEXT_PUBLIC_BASE_URL_DOTCOM || 'https://www.compassion.com';

export const defaultAuthRedirectUrl = new URL(defaultAuthRedirect);

/**
 * Returns true when `redirectUrl` belongs to the trusted environment
 * root (`trustedDomain`).
 */
export const isTrustedRedirect = (
  redirectUrl: URL | null,
  trustedDomain: string | null,
): boolean => {
  if (!redirectUrl || !trustedDomain) {
    return false;
  }

  const hostname = redirectUrl.hostname.toLocaleLowerCase();
  // Only trust the redirect when it's on our environment root and uses
  // an http(s) protocol (rejects javascript:, data:, etc.).
  return (
    (hostname === trustedDomain ||
      hostname.endsWith(`.${trustedDomain.toLocaleLowerCase()}`)) &&
    (redirectUrl.protocol === 'https:' || redirectUrl.protocol === 'http:')
  );
};
